var registerbooking = {
    text1:"PUNTOS GENERADOS:",
    pending:"PENDIENTES",
    available:"DISPONIBLES",
    text2:"Registra tus reservas para ganar dinero en efectivo",
    bookingSource: "Reservado por medio de",
    bookingNumber: "Numero de Reserva",
    clientName: "Nombre del Cliente",
    resort: "Hotel",
    select: "Seleccionar",
    date: "Fecha de llegada",
    date1: "Fecha de salida",
    room: "Tipo de Habitación",
    roomTotal: "Total de Noches",
    menuTour:"Menu Tour Operadores",
    enteredBy:"Te enteraste por",
    sendbtn: "Enviar",
    sentbtn: "Enviado",
    packagetotalcost:"Costo del paquete",
    addrow: "Agregar otra reserva +",
    addrowShort: "Agregar otra reserva",
    media: "GALERIA DE HOTELES",
    offers: "OFERTAS",
    error: "Ingresa un Origen de Reserva",
    error2: "Ingresa un numero de Reserva",
    error3: "Ingresa el nombre del Cliente",
    error4: "Selecciona un Hotel",
    invalidDate: "Fecha no valida",
    holderbooking:"Ingresa Origen",
    holderNumber:"Ingresa Numero",
    holderName:"Ingresa Nombre",
    residence:"Residencia",
    suite:"Suite",
    bedRoom:"1 recamara",
    other:"Otro",
    holderRoom:"Ingresa Total",
    holderTour:"Ingresa Tour",
    holderEntered:"Ingresa Fuente",
    notApply:"Nota: *El incentivo no se aplica a las reservas realizadas desde Canadá",
    isgroup:"Es un grupo?",
    groupyes:"Si",
    groupno: "No",
    groupNumber:"Cantidad de reservas",
    holderNumber1:"Ingresa Numero",
    notApplyGroups:"No aplica para grupos.",
    isThisAGroup:"¿Es esto un grupo?",
    lessrow:"Remover ultima fila -",
    lessrowShort:"Remover ultima reserva",
    bookingLabel:"Reserva #",
    various:"Varios",
    sendingMessage:"Espera un momento, estamos enviando tu solicitud",
    successRowMessage:"La reserva se envio correctamente.",
}
module.exports = registerbooking
